import { createFileRoute } from '@tanstack/react-router';
import { ResultsPane } from '../../../simops/-components/phase-views/ResultsPane';

export const Route = createFileRoute('/_app/evaltool/$studyId/results/compare')(
  {
    component: () => <ResultsPane mode="compare" />,
  },
);
